
// fairly simple wrapper that is only used for areabookings

import React,{ createContext, useContext, useEffect, useState } from "react";
import { useAreaPricingContext } from "./Daybook/DayBookContext";
import { calcCampaignTotals } from "../utils";

type CampaignContextValue = {
    calculateAreaPricing?:(row:any)=>number
}


export const CampaignContext = createContext<CampaignContextValue|null>({calculateAreaPricing:undefined});


export const useCampaignContext = ()=>{
    return useContext<CampaignContextValue>(CampaignContext);
}

export const CampaignContextProvider = ({campaign_start_date,campaign_created_at,children})=>{
    const areaPricingContext = useAreaPricingContext();
    const [state,setState] = useState<CampaignContextValue>({
        calculateAreaPricing:areaPricingContext?areaPricingContext({start_date:campaign_start_date,created_at:campaign_created_at}):undefined
    });
    useEffect(()=>{
        setState({
            calculateAreaPricing:areaPricingContext?areaPricingContext({start_date:campaign_start_date,created_at:campaign_created_at}):undefined
        });
    },[campaign_created_at,campaign_start_date]);
return <CampaignContext.Provider
    value={state}
  >
    {children}
  </CampaignContext.Provider>
}
